import service from '@/utils/request'
// 查询供应商地址
export function supplierAddressList(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAddress/supplierAddressList',
        data: param
    })
}
// 查询供应商地址 不分页
export function supplierAddressListAll() {
    return service.request({
        method: 'POST',
        url: '/app/supplierAddress/list',
    })
}
// 新增供应商地址
export function addSupplierAddress(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAddress/add',
        data: param
    })
}
// 修改供应商地址
export function editSupplierAddress(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAddress/edit',
        data: param
    })
}

// 批量删除供应商地址
export function batchDelSupplierAddress(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAddress/batchDel',
        data: param
    })
}



// 删除供应商地址
export function delSupplierAddress(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAddress/del',
        data: param
    })
}
// 导出供应商地址
export function exportSupplierAddress(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAddress/export',
        data: param
    })
}
